module.exports = __webpack_public_path__ + "img/25a-consultas-fiscais-historico.7aa6358d.png";